// extracted by css-extract-rspack-plugin
export default {"highlightedLineMenuButton":"HighlightedLineMenu-module__highlightedLineMenuButton__hVBhI","aiDisclaimer":"HighlightedLineMenu-module__aiDisclaimer__V9Fv5"};